/**
 * Human-readable display name lookups for sensor and relay IDs.
 * Returns the raw ID when no mapping is defined.
 */

const SENSOR_DISPLAY_NAMES = {
  'EmberSensor':       'Ember Sensor',
  'SmokeSensor':       'Smoke Sensor',
  'IRCameraSensor':    'IR Camera',
  'ControlBoxOnButton': 'Control Box ON Button',
};

const RELAY_DISPLAY_NAMES = {
  'WaterValveRelay': 'Main Water Valve',
  'WaterPumpRelay':  'Primary Pump',
};

/**
 * Returns the human-readable name for a sensor ID.
 * @param {string} sensorId
 * @returns {string}
 */
export function getSensorName(sensorId) {
  return SENSOR_DISPLAY_NAMES[sensorId] || sensorId;
}

/**
 * Returns the human-readable name for a relay ID.
 * @param {string} relayId
 * @returns {string}
 */
export function getRelayName(relayId) {
  return RELAY_DISPLAY_NAMES[relayId] || relayId;
}
